
import React from 'react';
import { TargetIcon } from './icons/TargetIcon';
import { ClockIcon } from './icons/ClockIcon';
import { ShieldIcon } from './icons/ShieldIcon';
import { TrendingUpIcon } from './icons/TrendingUpIcon';

const features = [
  {
    icon: <TargetIcon className="w-8 h-8 text-blue-500" />,
    title: 'Apply to All Programs',
    description: 'We automatically apply you to every forgiveness program you qualify for—no guessing needed.',
  },
  {
    icon: <ClockIcon className="w-8 h-8 text-green-500" />,
    title: 'Save Time',
    description: 'Complete your assessment in under 30 minutes. We handle all the complexity.',
  },
  {
    icon: <ShieldIcon className="w-8 h-8 text-blue-600" />,
    title: '100% Secure',
    description: 'Bank-level encryption protects your sensitive information.',
  },
  {
    icon: <TrendingUpIcon className="w-8 h-8 text-green-600" />,
    title: 'Maximize Savings',
    description: 'Multiple applications mean maximum chance of getting every dollar forgiven.',
  },
];

const FeatureCard: React.FC<{ feature: typeof features[0] }> = ({ feature }) => (
  <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-start text-left h-full">
    <div className="bg-gray-100 p-3 rounded-xl mb-6">
      {feature.icon}
    </div>
    <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
    <p className="text-gray-600">{feature.description}</p>
  </div>
);


const WhyChooseUs: React.FC = () => {
  return (
    <section className="py-16 sm:py-24">
      <div className="text-center">
        <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900">
          Why Choose <span className="bg-gradient-to-r from-[#2ECC40] to-[#0074D9] bg-clip-text text-transparent">ForgivePath?</span>
        </h2>
        <p className="mt-4 max-w-2xl mx-auto text-lg md:text-xl text-gray-600">
          We handle everything so you get every dollar possible forgiven
        </p>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
        {features.map((feature) => (
          <FeatureCard key={feature.title} feature={feature} />
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
